import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { useRecipes } from '../../hooks'
import { useActionRunner } from '../../../../../notification'

const CategoryFormModal = ({ editCategory, ...props }) => {
  const { createCategory, updateCategory } = useRecipes()
  const [modalOpen, setModalOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [doCreateCategory] = useActionRunner(createCategory)
  const [doUpdateCategory] = useActionRunner(updateCategory)

  const initialValues = useMemo(() => {
    return {
      name: '',
    }
  }, [])

  useEffect(() => {
    if (editCategory) {
      initialValues.name = editCategory.name
      setModalOpen(true)
    }
  }, [editCategory, initialValues])

  const handleCloseModal = () => {
    if (!isSubmitting) {
      setModalOpen(false)
    }
  }

  const handleSubmit = async values => {
    setIsSubmitting(true)
    try {
      if (editCategory && editCategory.id) {
        return await doUpdateCategory({
          id: editCategory.id,
          body: { name: values.name },
        })
      } else {
        return await doCreateCategory({
          name: values.name,
        })
      }
    } catch (error) {
      console.log(error)
    }
    setIsSubmitting(false)
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(FIELD_REQUIRED),
  })

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitText="Add"
      successNotification="Category Added"
      title="Add Category"
      validationSchema={validationSchema}
      open={modalOpen}
      onClose={handleCloseModal}
      {...props}
    >
      <Form>
        <FormikTextField
          fullWidth
          label="Category"
          margin="normal"
          name="name"
          type="text"
        />
      </Form>
    </FormikDialog>
  )
}

CategoryFormModal.propTypes = {
  selectedEnvironment: PropTypes.number,
  supplier: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  subject: PropTypes.string,
  trigger: PropTypes.func,
}

CategoryFormModal.defaultProps = {
  environmentId: '',
}

export default CategoryFormModal
